import { Link } from 'react-router-dom'
import {
  Container,
  Content,
  Empty,
  ExpandableList,
  List,
  Loading,
  MyQuestionBooks,
  QuickAccess,
  SeeMoreButton,
} from './styles'

import { MdSearch } from 'react-icons/md'
import { IoBookOutline } from 'react-icons/io5'
import TextDropdown from '../../../../components/TextDropdown'
import { useGetQuestionBooks } from '../../../MyQuestionBooks/hooks/use-get-question-books'
import { useRef, useState } from 'react'
import Card from './Card'
import { TQuestionBook } from './types'

const options = [
  { label: 'Mais recentes', value: 'new' },
  { label: 'Mais antigos', value: 'old' },
]

const QuestionsContent = () => {
  const expandableRef = useRef<HTMLDivElement | null>(null)
  const [isExpanded, setIsExpanded] = useState(false)

  const { swr, data, params } = useGetQuestionBooks()

  const isEmpty = swr.isLoading === false && data.length === 0

  const renderCard = (questionBook: TQuestionBook) => (
    <Card key={questionBook._id} data={questionBook} />
  )

  return (
    <Container>
      <Content>
        <QuickAccess>
          <div className="divBeta">
            <h1 className="title">Questões</h1>
          </div>
          <div className="cards">
            <Link to="/questoes/buscar" className="card">
              <MdSearch className="icon" />
              <p className="text">
                Buscar <br /> questões
              </p>
            </Link>
            <Link to="/questoes/cadernos" className="card">
              <IoBookOutline className="icon" />
              <p className="text">
                Ver <br /> cadernos
              </p>
            </Link>
          </div>
        </QuickAccess>

        <MyQuestionBooks>
          <div className="upper">
            <h2 className="title">Meus cadernos</h2>
            <TextDropdown
              options={options}
              defaultValue="new"
              onChange={(value) => params.setOrder(value as 'new' | 'old')}
              className="dropdown"
              disabled={data.length === 0}
            />
          </div>

          <List>{data.slice(0, 4).map(renderCard)}</List>

          {data.length > 4 && (
            <>
              <ExpandableList
                ref={expandableRef}
                isExpanded={isExpanded}
                fullHeight={expandableRef.current?.scrollHeight}
              >
                {data.slice(4).map(renderCard)}
              </ExpandableList>

              <SeeMoreButton type="button" onClick={() => setIsExpanded((state) => !state)}>
                Ver {isExpanded ? 'menos' : 'mais'}
              </SeeMoreButton>
            </>
          )}

          {swr.isLoading && (
            <Loading>
              <div className="loading-block"></div>
              <div className="loading-block"></div>
              <div className="loading-block"></div>
              <div className="loading-block"></div>
            </Loading>
          )}

          {isEmpty && (
            <Empty>
              <IoBookOutline className="icon" />

              <p className="text">
                Você ainda não tem nenhum caderno criado. <br /> Faça uma pesquisa e crie agora
                mesmo.
              </p>

              <Link to="/questoes/buscar" className="link">
                Buscar questões
              </Link>
            </Empty>
          )}
        </MyQuestionBooks>
      </Content>
    </Container>
  )
}

export default QuestionsContent
